import script from "./pc-module-task-analysis-5.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-task-analysis-5.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-task-analysis-5.vue?vue&type=style&index=0&id=24eff5a1&lang=scss"

const __exports__ = script;

export default __exports__